import Select from 'react-select'

const customStyles = (error) => ({
  option: (provided) => ({
    ...provided,
    padding: 20,
  }),
  container: (provided) => ({
    ...provided,
    minWidth: '20rem',
  }),
  input: () => ({
    opacity: '0',
  }),
  control: (provided) => ({
    ...provided,
    borderColor: !error ? 'hsl(0,0%,80%)': 'red',
    borderWidth: !error ? '1px': '1px',
    minHeight: '3rem',
  }),
})

export default function CustomSelect ({ defaultValue, value, options, placeholder, disabled, onChange, classNamePrefix, error=false, ...rest }) {
  return (
    <Select
      defaultValue={defaultValue}
      isSearchable={false}
      classNamePrefix={classNamePrefix}
      styles={customStyles(error)}
      value={value}
      options={options}
      placeholder={placeholder}
      isDisabled={disabled}
      onChange={onChange}
      {...rest}
    />
  )
}
